module.exports = __webpack_public_path__ + "static/img/eagle.c9b6d9c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/eagle.svg
// module id = zvdQ
// module chunks = 1